const BASE_URL = "https://billing.zinger.co.in";
const WEB_URL  = "https://saravanasjewellers.in";


export { BASE_URL , WEB_URL};
